import styled from 'styled-components'

export const ColorPickerContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 10px;
  width: 720px;
`

export const ColorGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

export const ColorPreview = styled.div`
  height: 28px;
  width: 28px;
  border-radius: 14px;
  background-color: ${({ color }) => color};
`
